import {KpiEN} from "./kpi/en";

export const evaluationKpiEN = {
    "evaluation-kpi": "KPI Evaluation",
    "evaluation": "Evaluation",
    ...KpiEN
}